
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/health",
      function () {
        return require("private-next-pages/[region]/health/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/health"])
      });
    }
  